import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import "core-js/modules/es.function.name.js";
import React from "react";
import { Box, Chip, Icon, Typography, RaiseColors, IconConstants, TextField } from "componentLibrary";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A multi-value input that allows users to add string values one at a time via Enter key.
 * Values are displayed as removable chips below the input.
 */
var TagInput = function TagInput(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    name = _ref.name,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "Enter 1 at a time" : _ref$placeholder,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    helperText = _ref.helperText,
    _ref$chipLabelTransfo = _ref.chipLabelTransform,
    chipLabelTransform = _ref$chipLabelTransfo === void 0 ? function (v) {
      return v;
    } : _ref$chipLabelTransfo,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth;
  var _React$useState = React.useState(""),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    inputValue = _React$useState2[0],
    setInputValue = _React$useState2[1];
  var valuesArray = value !== null && value !== void 0 ? value : [];
  var handleAdd = function handleAdd() {
    var _context;
    var trimmed = _trimInstanceProperty(inputValue).call(inputValue);
    if (!trimmed) return;
    var newValue = _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(valuesArray), [trimmed]);
    setInputValue("");
    onChange({
      target: {
        name: name,
        value: newValue
      }
    });
  };
  var handleInputChange = function handleInputChange(e) {
    setInputValue(e.target.value);
  };
  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAdd();
    }
  };
  var handleDelete = function handleDelete(indexToDelete) {
    return function () {
      var _context2;
      var newValues = _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(_sliceInstanceProperty(valuesArray).call(valuesArray, 0, indexToDelete)), _toConsumableArray(_sliceInstanceProperty(valuesArray).call(valuesArray, indexToDelete + 1)));
      onChange({
        target: {
          name: name,
          value: newValues
        }
      });
    };
  };
  return /*#__PURE__*/_jsxs(Box, {
    display: "flex",
    flexDirection: "column",
    sx: {
      gap: "8px"
    },
    width: fullWidth ? "100%" : undefined,
    children: [/*#__PURE__*/_jsx(TextField, {
      value: inputValue,
      onChange: handleInputChange,
      onKeyDown: handleKeyDown,
      placeholder: placeholder,
      disabled: disabled,
      helperText: helperText,
      fullWidth: fullWidth
    }), /*#__PURE__*/_jsx(Box, {
      display: "flex",
      flexWrap: "wrap",
      sx: {
        gap: "8px"
      },
      children: _mapInstanceProperty(valuesArray).call(valuesArray, function (item, index) {
        var _context3;
        return /*#__PURE__*/_jsx(Chip, {
          size: "small",
          sx: {
            backgroundColor: RaiseColors.science200,
            border: "1px solid ".concat(RaiseColors.science900)
          },
          label: /*#__PURE__*/_jsx(Typography, {
            color: RaiseColors.science900,
            weight: "medium",
            children: chipLabelTransform(item)
          }),
          onDelete: disabled ? undefined : handleDelete(index),
          deleteIcon: /*#__PURE__*/_jsx(Icon, {
            color: RaiseColors.science900,
            style: {
              marginRight: "11px"
            },
            fontSize: "16px",
            className: IconConstants.X
          })
        }, _concatInstanceProperty(_context3 = "".concat(item, "-")).call(_context3, index));
      })
    })]
  });
};
export default TagInput;